import ChartSingleValueIcon from '@splunk/react-icons/ChartSingleValueIcon';
import Circle from '@splunk/react-icons/Circle';
import Square from '@splunk/react-icons/Square';
import Markdown from '@splunk/react-icons/Markdown';

import { get } from 'lodash';
import type { PresetHOC } from '../types/PresetHOC';

const iconMap = {
    'splunk.markdown': Markdown,
    'splunk.ellipse': Circle,
    'splunk.rectangle': Square,
    'splunk.singlevalueicon': ChartSingleValueIcon,
};

export const withIcon: PresetHOC<
    {
        icon?: React.ComponentType;
    },
    { key: string }
> = (viz, { key } = {} as { key: string }) => {
    if (key in iconMap && !get(viz.config, 'icon')) {
        // eslint-disable-next-line no-param-reassign
        viz.config = {
            ...viz.config,
            icon: get(iconMap, key),
        };
    }
    return viz;
};
